import { fg } from '@atlassian/jira-feature-gating';

const JiraProjectPermissionSupportTeamsRelayProvider = {
	get(): boolean {
		return fg('support_teams_in_jira_project_permission');
	},
};

export default JiraProjectPermissionSupportTeamsRelayProvider;
